module.exports = __webpack_public_path__ + "static/img/logo98.1bb74fa.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo98.png
// module id = 7Ncz
// module chunks = 1